import React, { useEffect, useState } from "react";
import Breadcrumb from "../components/Breadcrumb";
import axios from "axios";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronDown, faChevronUp } from "@fortawesome/free-solid-svg-icons";

function FAQs() {
  const [content, setContent] = useState({ entries: [] });
  const [loading, setLoading] = useState(true);
  const [openIndexes, setOpenIndexes] = useState([]); // track multiple open FAQs

  useEffect(() => {
    const fetchContent = async () => {
      try {
        const response = await axios.get("/api/information/public/FAQs");
        setContent(response.data);
      } catch (error) {
        console.error("Error fetching FAQs content:", error);
      } finally {
        setLoading(false);
      }
    };
    fetchContent();
  }, []);

  const toggleFAQ = (index) => {
    setOpenIndexes((prev) =>
      prev.includes(index)
        ? prev.filter((i) => i !== index) // close if already open
        : [...prev, index] // add if closed
    );
  };

  if (loading) {
    return (
      <div className="bg-white min-h-screen flex items-center justify-center">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-gray-600 mx-auto"></div>
          <p className="mt-4 text-gray-700">Loading FAQs...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="bg-white min-h-screen">
      {/* Hero Section */}
      <div className="relative w-full h-[250px] md:h-[400px] overflow-hidden">
        <img
          src="/images/Teatro_alla_Scala.jpg"
          alt="Reviews Hero"
          className="w-full h-full object-cover"
        />
      </div>
      {/* Breadcrumb */}
      <Breadcrumb
        items={[
          { label: "Home", href: "/" },
          { label: "FAQs", href: "/FAQs" },
        ]}
      />
      {/* Main Content */}
      <main
        className="max-w-[1280px] mx-auto py-12 px-6 md:px-12"
        aria-label="FAQs"
      >
        <h1 className="text-4xl md:text-3xl text-left mb-4">
          FAQs
        </h1>
        {content.entries.length === 0 ? (
          <p className="text-black italic text-center py-12">
            No FAQs available at the moment.
          </p>
        ) : (
          <div className="space-y-4">
            {content.entries.map((entry, index) => (
              <div key={index}>
                <button
                  onClick={() => toggleFAQ(index)}
                  className="w-full flex justify-between items-center px-1 py-1 font-medium text-left text-lg"
                >
                  {entry.question}
                  <FontAwesomeIcon
                    icon={openIndexes.includes(index) ? faChevronUp : faChevronDown}
                    className="ml-2"
                  />
                </button>
                {openIndexes.includes(index) && (
                  <p className="px-1 pb-2 text-gray-700">{entry.answer}</p>
                )}
                <hr />
              </div>
            ))}
          </div>
        )}
      </main>
    </div>
  );
}

export default FAQs;
